export default class DeviceController {
  /**
   * Paul - Ive added iphone device type detection. My thinking was the small screen check is a
   * bit unfair for iphone 7 + users who have the RAM and power necessary to play the whole game.
   */
  constructor() {
    const w = screen.width;
    const h = screen.height;
    this.isOldIpad =
      window.devicePixelRatio == 1 &&
      ((w == 1024 && h == 768) || (w == 768 && h == 1024)) &&
      typeof window.androidBridge === 'undefined';
    this.isOldIphone = this.getIsOldiPhone();
    this.isKindle = this.isKindle();
    this.isNexus7 = navigator.userAgent.indexOf('Nexus 7') > -1;
    this.isGalaxyTab4 =
      navigator.userAgent.indexOf('SM-T530') > -1 ||
      navigator.userAgent.indexOf('SM-T330') > -1 ||
      navigator.userAgent.indexOf('GT-N8010') > -1;
    this.isSmallScreen = w <= 768 || h <= 768;
    this.brimPadding = 25;

    this.requiresLightVersion = Phaser.Device.desktop ? false : this.doesRequireLightVersion();

    // seperated these out so we can experiment easier with simple toggles
    this.allowTransitionTweens = this.requiresLightVersion == false;
  }

  getSettingsLog() {
    return [
      'Device Settings',
      'detects low end device : ' + this.requiresLightVersion,
      'game load type : ' + this.gameLoadType,
      'allow transition tweens : ' + this.allowTransitionTweens,
    ];
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  doesRequireLightVersion() {
    // light version for some devices detection

    if (
      this.isOldIpad ||
      this.isOldIphone ||
      this.isKindle ||
      this.isGalaxyTab4 ||
      this.isNexus7
      // this.isSmallScreen
    ) {
      return true;
    }

    return false;
  }

  // detection code from https://stackoverflow.com/questions/21825157/internet-explorer-11-detection/29715168
  isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }

  isKindle() {
    let devices = [
      'KFSUWI',
      'KFAUWI',
      'KFDOWI',
      'KFGIWI',
      'KFFOWI',
      'KFMEWI',
      'KFTBWI',
      'KFARWI',
      'KFASWI',
      'KFSAWA',
      'KFSAWI',
      'KFAPWA',
      'KFAPWI',
      'KFAPWA',
      'KFAPWI',
      'KFSOWI',
      'KFJWA',
      'KFJWI',
      'KFTT',
      'KFOT',
      'Kindle Fire',
    ];
    for (let i = 0; i < devices.length; i++) {
      if (navigator.userAgent.indexOf(devices[i]) > -1) {
        return true;
      }
    }

    return false;
  }

  applyLightSettings(value) {
    this.requiresLightVersion = value;
  }

  getIsOldiPhone() {
    const model = this.getiPhoneModel();
    return (
      model === DeviceController.iPHONE1_3 ||
      model === DeviceController.iPHONE4_4S ||
      model === DeviceController.iPHONE5_5C_5S
    );
  }

  requireBrimPadding() {
    // return true;

    if (this.getiPhoneModel() === DeviceController.iPHONE5_5C_5S) {
      return true;
    }

    return false;
  }

  // iPhone model checks.
  // https://51degrees.com/blog/device-detection-for-apple-iphone-and-ipad
  // https://analytical42.com/2017/detect-and-track-iphone-models-in-google-analytics/
  getiPhoneModel() {
    if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
      const width =
        window.screen.width > window.screen.height ? window.screen.height : window.screen.width;
      const height =
        window.screen.width > window.screen.height ? window.screen.width : window.screen.height;
      const wh = width / height;
      const ratio = window.devicePixelRatio;

      if (wh == 320 / 480 && ratio == 1) {
        return DeviceController.iPHONE1_3;
      }

      if (wh == 640 / 960 && ratio == 2) {
        return DeviceController.iPHONE4_4S;
      }

      if (wh == 640 / 1136 && ratio == 2) {
        return DeviceController.iPHONE5_5C_5S;
      }

      if (wh == 750 / 1334 && ratio == 2) {
        return DeviceController.iPHONE6_6S_7_8;
      }

      if (wh == 640 / 1136 && ratio == 2) {
        return DeviceController.iPHONE6_6S_7_8_DZ;
      }

      if (wh == 1242 / 2208 && ratio == 3) {
        return DeviceController.iPHONE6_6S_7P_8P;
      }

      if (wh == 1125 / 2001 && ratio == 3) {
        return DeviceController.iPHONE6_6S_7P_8P_DZ;
      }

      if (wh == 375 / 812 && ratio == 3) {
        return DeviceController.iPHONEX;
      }
      return '';
    } else {
      return '';
    }
  }
}
DeviceController.iPHONE1_3 = 'iPhone 1/3g/3gs';
DeviceController.iPHONE4_4S = 'iPhone 4/4s';
DeviceController.iPHONE5_5C_5S = 'iPhone 5/5c/5s';
DeviceController.iPHONE6_6S_7_8 = 'iPhone 6/6s/7/8';
DeviceController.iPHONE6_6S_7_8_DZ = 'iPhone 6/6s/7/8 (Display Zoom)';
DeviceController.iPHONE6_6S_7P_8P = 'iPhone 6/6s/7 Plus/8 Plus';
DeviceController.iPHONE6_6S_7P_8P_DZ = 'iPhone 6/6s/7 Plus/8 Plus (Display Zoom)';
DeviceController.iPHONEX = 'iPhone X';



// WEBPACK FOOTER //
// ./js/app/controller/DeviceController.js